import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const days = Array.from({
  length: 31
}, (_, i) => String(i + 1));
const years = Array.from({
  length: 10
}, (_, i) => String(2026 - i));
const hours = Array.from({
  length: 12
}, (_, i) => String(i + 1));
const minutes = Array.from({
  length: 60
}, (_, i) => String(i).padStart(2, '0'));
export function EditCourseStatus() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  return <div className="space-y-4" data-id="element-636">
      <div className="flex items-center justify-between" data-id="element-637">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-638">
          Edit Course Status
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/profile')} data-id="element-639">
          ← Back to Profile
        </Button>
      </div>

      <Card data-id="element-640">
        <CardContent className="pt-6" data-id="element-641">
          <form className="space-y-4 max-w-md" data-id="element-642">
            <div data-id="element-643">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-644">
                Completed
              </label>
              <div className="flex items-center gap-1 flex-wrap" data-id="element-645">
                <select defaultValue="March" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-646">
                  {months.map(m => <option key={m} data-id="element-647">{m}</option>)}
                </select>
                <select defaultValue="2" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-648">
                  {days.map(d => <option key={d} data-id="element-649">{d}</option>)}
                </select>
                <select defaultValue="2026" className="h-8 w-20 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-650">
                  {years.map(y => <option key={y} data-id="element-651">{y}</option>)}
                </select>
                <select defaultValue="2" className="h-8 w-14 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-652">
                  {hours.map(h => <option key={h} data-id="element-653">{h}</option>)}
                </select>
                <select defaultValue="33" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-654">
                  {minutes.map(m => <option key={m} data-id="element-655">{m}</option>)}
                </select>
                <select defaultValue="pm" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-656">
                  <option value="am" data-id="element-657">am</option>
                  <option value="pm" data-id="element-658">pm</option>
                </select>
              </div>
            </div>

            <div className="pt-2" data-id="element-659">
              <Button type="submit" data-id="element-660">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}